import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, CardActions, CardContent, CardHeader, Divider, Grid } from '@material-ui/core';
import { SelectValidator, TextValidator } from 'react-material-ui-form-validator';
import InputMask from 'react-input-mask';
import { SexoValues } from '../../../../values/SexoValues';
import MenuItem from '@material-ui/core/MenuItem';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import CardActionArea from '@material-ui/core/CardActionArea';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import GridList from '@material-ui/core/GridList';
import { useStyles } from './UsuarioProfileDetailsStyles';
import DialogEditEndereco from '../../../../components/DialogEditEndereco/DialogEditEndereco';
import DialogEditTelefone from '../../../../components/DialogEditTelefone/DialogEditTelefone';
import AddIcon from '@material-ui/icons/Add';


const UsuarioProfileDetails = props => {
  const {
    className,
    usuario,
    setUsuario,
    updateUsuario,
    getUsuario,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    ...rest } = props;
  const [edicaoPerfil, setEdicaoPerfil] = useState(false);
  const [maskCpf] = useState('999.999.999-99');
  const [refreshState, setRefreshState] = useState(new Date());
  const [openDialogEditEndereco,setOpenDialogEditEndereco] = useState(false);
  const [indexEnderecoSelecionado, setIndexEnderecoSelecionado] = useState(-1);
  const [openDialogEditTelefone,setOpenDialogEditTelefone] = useState(false);
  const [indexTelefoneSelecionado, setIndexTelefoneSelecionado] = useState(-1);
  const [edicaoEndereco, setEdicaoEndereco] = useState(true);
  const [edicaoTelefone, setEdicaoTelefone] = useState(true);
  const classes = useStyles();

  function editarPerfil() {
    setEdicaoPerfil(true);
  }

  function modificarValores(order, value){
    switch (order) {
      case 0:
        usuario.nome = value;
        setUsuario(usuario);
        break;
      case 1:
        usuario.nomeFantasia = value;
        setUsuario(usuario);
        break;
      case 2:
        usuario.email = value;
        setUsuario(usuario);
        break;
      case 3:
        usuario.cpfCnpj = value;
        setUsuario(usuario);
        break;
      case 4:
        usuario.sexo = value;
        setUsuario(usuario);
        break;
      case 5:
        usuario.dataNascimento = value;
        setUsuario(usuario);
        break;
      case 6:
        usuario.idTipoUsuario = value;
        setUsuario(usuario);
        break;
      case 7:
        usuario.login = value;
        setUsuario(usuario);
        break;
      case 8:
        usuario.senha = value;
        setUsuario(usuario);
        break;
    }
    setRefreshState(new Date());
  }

  function cancelarEdicao() {
    setEdicaoPerfil(false);
    getUsuario();
  }

  async function salvarPerfil() {
    setUsuario(usuario);
    setEdicaoPerfil(false);
    setRefreshState(new Date());
    await updateUsuario(usuario);
    console.log(usuario);
    setUsuario(usuario);
    setRefreshState(new Date());
  }

  const handleChangeDatNascimento = date => {
    usuario.dataNascimento = date;
    setUsuario(usuario);
    setRefreshState(new Date());
  };

  function removerEndereco(event, index) {
    if(edicaoPerfil){
      if(usuario.enderecos[index].idEndereco){
        usuario.enderecos[index].cep = undefined;
        setUsuario(usuario);
        setRefreshState(new Date());
      }
      else{
        usuario.enderecos.splice(index, 1);
        setUsuario(usuario);
        setRefreshState((new Date()).toString());
      }
    }
    else{
      setMessageSnack('Clique no botão \'EDITAR PERFIL\' para poder alterar informações do seu perfil');
      setTypeSnack('warning');
      setShowMessageSnack(true);
    }
  }

  function removerTelefone(event, index) {
    if(edicaoPerfil){
      if(usuario.telefones[index].idTelefone){
        usuario.telefones[index].telefone = undefined;
        setUsuario(usuario);
        setRefreshState(new Date());
      }
      else{
        usuario.telefones.splice(index, 1);
        setUsuario(usuario);
        setRefreshState((new Date()).toString());
      }
    }
    else{
      setMessageSnack('Clique no botão \'EDITAR PERFIL\' para poder alterar informações do seu perfil');
      setTypeSnack('warning');
      setShowMessageSnack(true);
    }

  }

  function editEndereco(index) {
    if(edicaoPerfil){
      setIndexEnderecoSelecionado(index);
      setEdicaoEndereco(true);
      setOpenDialogEditEndereco(true);
    }
    else{
      setMessageSnack('Clique no botão \'EDITAR PERFIL\' para poder alterar informações do seu perfil');
      setTypeSnack('warning');
      setShowMessageSnack(true);
    }

  }

  function editTelefone(index) {
    if(edicaoPerfil){
      setIndexTelefoneSelecionado(index);
      setEdicaoTelefone(true);
      setOpenDialogEditTelefone(true);
    }
    else{
      setMessageSnack('Clique no botão \'EDITAR PERFIL\' para poder alterar informações do seu perfil');
      setTypeSnack('warning');
      setShowMessageSnack(true);
    }
  }

  function adicionarTelefone() {
    if(edicaoPerfil){
      setEdicaoTelefone(false);
      setOpenDialogEditTelefone(true);
    }
    else{
      setMessageSnack('Clique no botão \'EDITAR PERFIL\' para poder alterar informações do seu perfil');
      setTypeSnack('warning');
      setShowMessageSnack(true);
    }
  }

  function adicionarEndereco() {
    if(edicaoPerfil){
      setEdicaoEndereco(false);
      setOpenDialogEditEndereco(true);
    }
    else{
      setMessageSnack('Clique no botão \'EDITAR PERFIL\' para poder alterar informações do seu perfil');
      setTypeSnack('warning');
      setShowMessageSnack(true);
    }

  }

  return (
    <div>
      <Card
        {...rest}
      >
        <DialogEditEndereco
          usuario={usuario}
          setUsuario={setUsuario}
          open={openDialogEditEndereco}
          setOpen={setOpenDialogEditEndereco}
          index_endereco={indexEnderecoSelecionado}
          setIndex_endereco={setIndexEnderecoSelecionado}
          edicao={edicaoEndereco}
        />
        <DialogEditTelefone
          usuario={usuario}
          setUsuario={setUsuario}
          open={openDialogEditTelefone}
          setOpen={setOpenDialogEditTelefone}
          index_telefone={indexTelefoneSelecionado}
          setIndex_telefone={setIndexTelefoneSelecionado}
          edicao={edicaoTelefone}
        />
        <form
          autoComplete="off"
          noValidate
        >
          <CardHeader
            subheader={!edicaoPerfil ? "Clique em editar para alterar suas informações de perfil." : "Clique em salvar para manter suas alterações de perfil."}
            title="Perfil"
          >
          </CardHeader>
          <CardActions>
            {edicaoPerfil &&
            <Button
              color="primary"
              variant="contained"
              onClick={e => cancelarEdicao()}
            >
              Cancelar
            </Button>
            }
            {!edicaoPerfil ?
              <Button
                color="primary"
                variant="contained"
                onClick={e => editarPerfil()}
              >
                Editar perfil
              </Button>
              :
              <Button
                color="primary"
                variant="contained"
                onClick={e => salvarPerfil()}
              >
                Salvar perfil
              </Button>
            }

          </CardActions>
          <Divider />
          <CardContent>
            <Grid
              container
              spacing={3}
            >
              <Grid
                item
                md={12}
                xs={12}
              >
                <TextValidator
                  fullWidth
                  label="Nome completo"
                  helperText="Insira o nome completo do usuário."
                  margin="dense"
                  disabled={!edicaoPerfil}
                  name="nome_usuario"
                  value={usuario.nome}
                  onChange={e => modificarValores(0, e.target.value)}
                  variant="outlined"
                  validators={['required', 'minStringLength:3', 'maxStringLength:155']}
                  errorMessages={['Insira o nome completo do usuário.', 'Nome muito curto.', 'Nome muito longo.']}
                />
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextValidator
                  fullWidth
                  disabled={!edicaoPerfil}
                  label="Apelido"
                  helperText="Insira um apelido para o usuário."
                  margin="dense"
                  name="nomeFantasia"
                  value={usuario.nomeFantasia}
                  onChange={e => modificarValores(1, e.target.value)}
                  variant="outlined"
                  validators={['required', 'maxStringLength:20']}
                  errorMessages={['Insira um apelido para o usuário.', 'Apelido muito longo.']}
                />
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <InputMask
                  mask={maskCpf}
                  value={usuario.cpfCnpj}
                  disabled={!edicaoPerfil}
                  onChange={e => modificarValores(3, e.target.value)}
                >
                  {
                    (inputProps) =>
                      <TextValidator
                        fullWidth
                        label="CPF"
                        margin="dense"
                        name="cnpj"
                        onChange={inputProps.onChange}
                        disabled={!edicaoPerfil}
                        type="text"
                        variant="outlined"
                        validators={['required']}
                        errorMessages={['Insira o CPF do usuário.']  }
                      />

                  }
                </InputMask>
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container justify="space-around">
                    <KeyboardDatePicker
                      fullWidth
                      margin="dense"
                      inputVariant="outlined"
                      orientation="landscape"
                      id="dataNascimento"
                      disabled={!edicaoPerfil}
                      onChange={handleChangeDatNascimento}
                      label="Data de Nascimento"
                      helperText={'Insira a data de nascimento'}
                      format="dd/MM/yyyy"
                      size='small'
                      value={usuario.dataNascimento}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      InputAdornmentProps={{ position: "end" }}
                    />

                  </Grid>
                </MuiPickersUtilsProvider>
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <SelectValidator
                  fullWidth
                  helperText="Insira o sexo do usuário."
                  label="Sexo"
                  margin="dense"
                  name="sexo"
                  disabled={!edicaoPerfil}
                  value={usuario.sexo}
                  onChange={e => modificarValores(4, e.target.value)}
                  variant="outlined"
                  validators={['required']}
                  errorMessages={['Insira o sexo do usuário.']}
                >
                  {SexoValues.map((sexo, index) => (
                    <MenuItem key={index} value={sexo.value}>{sexo.label}</MenuItem>
                  ))}

                </SelectValidator>
              </Grid>
            </Grid>
          </CardContent>
          <CardHeader
            subheader={"Edite as suas informações de contatos."}
            title="Contatos"
          >
          </CardHeader>
          <Divider />
          <CardContent>

            {
              usuario.idUsuario &&
              <CardHeader
                title="Telefones"
              />
            }
            <GridList className={classes.gridList} cols={5} spacing={10}>
              {
                usuario.idUsuario &&
                <Card className={classes.card}>
                  <CardContent>
                    <IconButton
                      aria-label="delete"
                      className={classes.cardAdd}
                      onClick={e => adicionarTelefone()}
                    >
                      <AddIcon
                        style={{fontSize: 50}}
                        color={'action'}
                      />
                    </IconButton>
                  </CardContent>
                </Card>
              }
              {usuario.telefones.map((telefone, index) => (
                telefone.telefone &&
                <Card className={classes.card}>
                  <CardActionArea
                    onClick={e => editTelefone(index)}
                  >

                    <CardContent>
                      <Typography gutterBottom variant="h5" component="h2" >
                        {"Telefone " + (index + 1)}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" component="p">
                        {"(" + telefone.ddd + ") " + telefone.telefone }
                      </Typography>
                      <Typography variant="body2" color="textSecondary" component="p">
                        {telefone.telefone_fixo ? 'Telefone Fixo' : 'Telefone Celular'}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <IconButton
                      aria-label="delete"
                      className={classes.expand}
                      onClick={e => removerTelefone(e, index)}

                    >
                      <DeleteIcon
                        fontSize={'small'}
                        color={'action'}
                      />
                    </IconButton>
                  </CardActions>
                </Card>
              ))}
            </GridList>

            {
              usuario.idUsuario &&
              <CardHeader
                title="Endereços"
              />
            }


            <GridList className={classes.gridList} cols={5} spacing={10}>
              {
                usuario.idUsuario &&
                <Card className={classes.card}>
                  <CardContent>
                    <IconButton
                      aria-label="delete"
                      className={classes.cardAdd}
                      onClick={e => adicionarEndereco()}
                    >
                      <AddIcon
                        style={{fontSize: 50}}
                        color={'action'}
                      />
                    </IconButton>
                  </CardContent>
                </Card>
              }
              {usuario.enderecos.map((endereco, index) => (
                endereco.cep &&
                <Card className={classes.card} key={index}>
                  <CardActionArea
                    onClick={e => editEndereco(index)}
                  >

                    <CardContent>
                      <Typography gutterBottom variant="h5" component="h2">
                        {endereco.apelido}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" component="p">
                        {"CEP: " + endereco.cep}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" component="p">
                        {endereco.logradouro + ", " + endereco.numero + ", " + endereco.bairro + (endereco.complemento && endereco.complemento !== "" ? ", " + endereco.complemento : "") +
                        ", " + endereco.cidade + " - " + endereco.uf}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" component="p">
                        {"Código IBGE: " + endereco.codigoIbge}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <IconButton
                      aria-label="delete"
                      className={classes.expand}
                      onClick={e => removerEndereco(e, index)}

                    >
                      <DeleteIcon
                        fontSize={'small'}
                        color={'action'}
                      />
                    </IconButton>
                  </CardActions>
                </Card>
              ))}
            </GridList>

          </CardContent>
          <Divider />

        </form>
      </Card>
    </div>
  );
};

UsuarioProfileDetails.propTypes = {
  className: PropTypes.string
};

export default UsuarioProfileDetails;
